import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import qs from 'qs'
import './common/public.css'
import api from './api' // 导入api接口
import {
    Button
} from 'vant';
import {
    NavBar
} from 'vant';
import {
    Form
} from 'vant';
import {
    Field
} from 'vant';
import {
    RadioGroup,
    Radio
} from 'vant';
import {
    Picker
} from 'vant';
import {
    Uploader
} from 'vant';
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
    Image as VanImage
} from 'vant';
import 'amfe-flexible/index.js'
import {
    Cell,
    CellGroup
} from 'vant';
import {
    Popup
} from 'vant';
import {
    Checkbox,
    CheckboxGroup
} from 'vant';
import {
    Progress
} from 'vant';
import {
    Step,
    Steps
} from 'vant';
import {
    Area
} from 'vant';
import {
    Dialog
} from 'vant';
import {
    Lazyload
} from 'vant';
import VueAliplayerV2 from 'vue-aliplayer-v2';
import {
    Swipe,
    SwipeItem
} from 'vant';
import {
    Overlay
} from 'vant';
// 全局注册
Vue.use(Overlay);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(VueAliplayerV2);
Vue.use(Lazyload);
Vue.use(Dialog);
Vue.use(Area);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Progress);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Popup);
Vue.use(Cell);
Vue.use(CellGroup);

Vue.use(VanImage);
Vue.use(VueAxios, axios)
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Field);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Form);

Vue.config.productionTip = false
Vue.prototype.$api = api; // 将api挂载到vue的原型上
// Vue.prototype.$qs = qs;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')